<template>
  <div class="power_setting" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="roleName" placeholder="请输入角色名称" title="角色名称" />
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="info" style="margin-left: 10px;"   @click="addRole" v-if="roleList['9_2-1']">添加</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe ref="selection"  @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
        <el-table-column  fixed="right" label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button v-if="roleList['9_2-2'] && scope.row.roleDesc!='初始化企业管理员'" @click="editPower(scope.row.id)" type="text" size="small">编辑</el-button>
            <el-tooltip class="item" effect="light" content="初始化企业管理员不可编辑" placement="top">
                <el-button v-if="roleList['9_2-2'] && scope.row.roleDesc=='初始化企业管理员'" style="color: #cccccc !important;cursor:not-allowed !important;" type="text" size="small">编辑</el-button>
            </el-tooltip>
            <el-button v-if="roleList['9_2-3'] && scope.row.roleDesc!='初始化企业管理员'" @click="deleteRole(scope.row.id)" type="text" size="small">删除</el-button>
            <el-tooltip class="item" effect="light" content="初始化企业管理员不可删除" placement="top">
                <el-button v-if="roleList['9_2-3'] && scope.row.roleDesc=='初始化企业管理员'" style="color: #cccccc !important;cursor:not-allowed !important;" type="text" size="small">删除</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small"  :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <InsertPowerPop :showInsertPower="showInsertPower" :searchId="searchId" @closeInsertPower="closeInsertPower"></InsertPowerPop>
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import InsertPowerPop from '@/components/userManagement/InsertPowerPop.vue'
    export default {
        name: "PowerSetting",
        mixins:[publicFunClass],
        components:{
          InsertPowerPop
        },
        props:{
          pageCode:String
        },
        data(){
          return{
            showPageCount:0,
            roleName:'',
            spinShow:true,
            tableHeight:600,
            screenHeight:{height:''},
            showInsertPower:false,
            total:0,
            searchId:'',
            roleList:JSON.parse(localStorage.getItem("roleList")),
            pageSizeList:[10,20,30,40,50,100,200],
            speedChangePage: 1,
            currentPage:1,
            pageSize:20,
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            fieldList: [{key:'roleName','title':'角色名称', width:"200"}, {key:'roleDesc','title':'备注'}],
            contentList: [],
            tableClass: true,
            selection:''
          }
        },
        methods:{
          closeInsertPower:function(flag){
            this.showInsertPower=false;
            if(flag){
              this.initSearch();
            }
          },
          addRole:function () {
            this.searchId="";
            this.showInsertPower=true;
          },
          deleteRole:function (id) {
            let that=this;
            let param={
              id:id+'',
              journalType:"用户管理==>角色管理==>删除",
              menuId:"9_2-3"
            };
            this.$Modal.confirm({
              title: '提示',
              content: "是否确定删除",
              onOk: () => {
                that.$http.post("role/doDelete.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("删除成功");
                  that.initSearch();
                })
              }
            });
          },
          editPower:function (id) {
            this.searchId=id+'';
            this.showInsertPower=true;
          },
          initSearch:function () {
            let that=this;
            this.spinShow=true;
            let param={
              roleName:this.roleName,
              pageNum:this.currentPage,
              pageSize:this.pageSize,
              journalType:"null",
              menuId:"null",
              id:''
            };
            this.$http.post("role/toIndex.json",param) .then(function (res) {
              that.spinShow=false;
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.contentList=res.data.obj.list.content;
              console.log(that.contentList);
              that.total=res.data.obj.list.totalSize;
            })
          }
        },
        created(){
          this.screenHeight.height=this.mountHeight(91);
          let clientHeight=document.documentElement.clientHeight;
          this.tableHeight=clientHeight-182;
        },
        watch:{
          pageCode:function () {
            if(this.pageCode=='9_2' && this.showPageCount==0){
              this.showPageCount++;
              this.initSearch();
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/userManagement/PowerSetting.vue